export var DISABLE_LANGUAGE_SELECTOR = process.env.LANG_SELECTION === "0";
export var LANG_COOKIE = "kportal_lang";
